import React, { useState } from 'react';
import { Menu } from '@material-ui/core';

const CustomMenu = ({
  children,
  anchorOrigin,
  transformOrigin,
  displayComponent,
  style,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleMenu = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const Display = displayComponent;
  return (
    <div>
      <Display
        aria-owns={open ? 'menu-appbar' : undefined}
        aria-haspopup="true"
        onClick={handleMenu}
      />
      <Menu
        style={style}
        id="menu-appbar"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        open={open}
        getContentAnchorEl={null}
        onClose={handleClose}
        onClick={handleClose}
      >
        {children}
      </Menu>
    </div>
  );
};

export default CustomMenu;
